import { render, staticRenderFns } from "./SignupPage.vue?vue&type=template&id=2aa752ba&"
import script from "./SignupPage.vue?vue&type=script&lang=ts&"
export * from "./SignupPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2aa752ba')) {
      api.createRecord('2aa752ba', component.options)
    } else {
      api.reload('2aa752ba', component.options)
    }
    module.hot.accept("./SignupPage.vue?vue&type=template&id=2aa752ba&", function () {
      api.rerender('2aa752ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Auth/SignupPage.vue"
export default component.exports